import { u_ } from "@pressmedia/webappbase";

export default {
	/**
	 * 指定されたidのデータを取得する
	 * @param {String} itemId
	 * @returns Promise
	 */
	async loadItemById(itemId) {
		if( !itemId || ( !u_.isString(itemId) && !u_.isNumber(itemId) ) ) {
			throw new TypeError("arguments[0] must be string and required.");
		}
		
		// 元のgetFilterを退避
		const getFilter = this.getFilter;
		
		// id指定での取得用のgetFilterをセット
		this.getFilter = {
			conditions: [{
				targetParam: "itemId",
				condition: "eq",
				value: itemId
			}]
		};
		
		return this.loadItems((err, res) => {
			// 退避したgetFilterを戻す
			this.getFilter = getFilter;
		});
	},
	
	/**
	 * データの削除関数１
	 * @param {String} itemId
	 * @param {Function} [callback]
	 * @returns Promies
	 */
	async deleteItem(itemId, callback) {
		if( !itemId || ( !u_.isString(itemId) && !u_.isNumber(itemId) ) ) {
			return false;
		}
		
		// [send request]
		return this._sendRequest("deleteItem", {
			type: "DELETE",
			endPoint: itemId
		}, callback);
	},
	
	/**
	 * データの削除関数２
	 * @param {Array} conditions
	 * @param {Function} [callback]
	 * @returns
	 */
	async deleteItems(conditions, callback) {
		const fltr = this.parseFilter({ conditions });
		if(!Object.keys(fltr).length) {
			return false;
		}
		
		// [send request]
		return this._sendRequest("deleteItems", {
			type: "DELETE",
			data: fltr
		}, callback);
	},
	
	/*----------------
	* 特定項目の更新関数
	* @return Promise
	*/
	/**
	 * 特定項目の更新関数
	 * @param {String} itemId
	 * @param {String} paramKey
	 * @param {any} value
	 * @param {Function} [callback]
	 * @returns Promise
	 */
	async updateItem(itemId, paramKey, value, callback) {
		if( !itemId || ( !u_.isString(itemId) && !u_.isNumber(itemId) ) ) {
			return false;
		}
		if( !paramKey || !u_.isString(paramKey) ) {
			return false;
		}
		
		// [send request]
		return this._sendRequest("updItem", {
			type: "PUT",
			endPoint: `${itemId}/${paramKey}`,
			data: { value }
		}, callback);
	},
	
	/**
	 * inpType: flg項目の変更関数
	 * @param {String} itemId
	 * @param {String} paramKey
	 * @param {Function} [callback]
	 * @returns Promise
	 */
	async changeItemFlg(itemId, paramKey, callback) {
		if( !u_.isString(itemId) && !u_.isNumber(itemId) ) {
			return false;
		}
		if( !paramKey || !u_.isString(paramKey) ) {
			return false;
		}
		
		// [send request]
		return this._sendRequest("changeItemFlg", {
			type: "PUT",
			endPoint: `${itemId}/${paramKey}`,
		}, callback);
	},
	
	/**
	 * CSVファイル作成リクエストを送信する関数
	 * @param {Function} callback
	 * @returns Promise
	 */
	async createCsv(callback) {
		let endPoint = "csv";
		const reqData = this.parseFilter(this.getFilter);
		if(
			reqData.itemId &&
			reqData.itemId.indexOf(":") < 0 &&
			reqData.itemId !== "NULL"
		) {
			endPoint = `${reqData.itemId}/${endPoint}`;
			delete reqData.itemId;
		}
		
		// 全件取得
		!!reqData.offset && (delete reqData.offset);
		!!reqData.limit && (delete reqData.limit);
		
		// [send request]
		return this._sendRequest("createCsv", {
			type: "GET",
			endPoint: endPoint,
			data: reqData
		}, callback);
	}
};
